import React from 'react';

import { Button, Form, Input, Space, Typography } from 'antd';
import { FormikProps } from 'formik';

import {
  IWebhookConfigUpsert,
  WEBHOOK_AUTH_TYPE,
  WebhookAuthType,
} from '../types';

interface IWebhookFormValues extends IWebhookConfigUpsert {
  authType: WebhookAuthType;
}

interface IWebhookFormProps {
  formik: FormikProps<IWebhookFormValues>;
}

const AUTH_TYPE_OPTIONS = [
  { label: 'Public', value: WEBHOOK_AUTH_TYPE.PUBLIC },
];

export const WebhookForm = ({ formik }: IWebhookFormProps) => {
  const { values, errors, touched, handleChange, handleBlur, setFieldValue } =
    formik;

  return (
    <Form layout="vertical">
      <Form.Item
        label="URL:"
        validateStatus={touched.url && errors.url ? 'error' : ''}
        help={touched.url && errors.url ? errors.url : ''}
      >
        <Input
          name="url"
          value={values.url}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="https://"
          data-testid="webhook-url-input"
        />
      </Form.Item>

      <Typography.Text strong>AUTHORISATION TYPE:</Typography.Text>
      <Form.Item style={{ marginTop: 8 }}>
        <Space>
          {AUTH_TYPE_OPTIONS.map((authType) => (
            <Button
              key={authType.value}
              type={values.authType === authType.value ? 'primary' : 'default'}
              onClick={() => setFieldValue('authType', authType.value)}
              data-testid={`webhook-auth-${authType.value}-button`}
            >
              {authType.label}
            </Button>
          ))}
        </Space>
      </Form.Item>
    </Form>
  );
};

export type { IWebhookFormValues };
